import { LinearGradient } from "expo-linear-gradient";
import { Modal, StyleSheet, Text, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import { MaterialIcons } from "@expo/vector-icons";
import { useState } from "react";

export default function sendRequest() {
  const [requestModal, setRequestModal] = useState(false);

  return (
    <View>
      {/* button that allows the user to search for a book: opens the screen if pressed */}
      <TouchableOpacity
        onPress={() => setRequestModal(true)}
        // style={buttonStyle}
      >
        <Text>REQUEST A BOOK</Text>
      </TouchableOpacity>

      {/* Screen that allows the user to search for a book */}
      <Modal visible={requestModal} animationType={"fade"}>
        <LinearGradient colors={["#66524a", "#332b2d"]} style={{ flex: 1 }}>
          {/* 'X' Icon that closes the screen*/}
          <MaterialIcons
            name="close"
            size={30}
            style={styles.modalClose}
            onPress={() => setRequestModal(false)}
          />
        </LinearGradient>
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  modalClose: {
    marginTop: 60,
    color: "#E2CFC2",
    marginHorizontal: 10,
  },
});
